<template>
  <div class="register">
    <b-container class="p-0 pm-2">
      <b-card class="card-login">
        <img
          v-if="logoSrc"
          :src="getImgUrl(logoSrc)"
          class="d-block mx-auto loginIconImg auth-logo-dy mb-4"
        />
        <h2 v-if="titleH2" class="mt-3 mb-3" v-html="titleH2"></h2>
        <b-row>
          <b-col>
            <h6
              v-if="welcomeHeader"
              class="welecomeH6 mt-1 mb-3"
              v-bind:class="{
                welecomeMIDH6: client_name == 'MID',
                'welecomeDYH6 text-center': client_name == 'DY',
              }"
            >
              {{ welcomeHeader }}
            </h6>
            <p
              v-if="welcomeSubheader"
              class="welcomeP"
              v-bind:class="{
                welecomeMIDP: client_name == 'MID',
                welecomeDYP: client_name == 'DY',
              }"
            >
              {{ welcomeSubheader }}
            </p>
          </b-col>
        </b-row>
        <b-row
          ><b-col>
            <!-- -->
            <b-alert
              v-model="showRegisterErrorMessage"
              variant="danger"
              :class="{
                'alert-danger-dy': client_name == 'DY',
              }"
              >{{ registerErrorMessage }}
            </b-alert>
          </b-col></b-row
        >
        <b-form @submit.prevent="onSubmit">
          <b-row>
            <b-col>
              <b-form-group id="first-name-input-group">
                <b-form-input
                  class="form-control-auth"
                  v-bind:class="{
                    'form-control-auth-mid': client_name == 'MID',
                    'form-control-auth-doom-yoga': client_name == 'DY',
                  }"
                  id="first_name"
                  v-model="form.first_name"
                  type="text"
                  placeholder="First name"
                  required
                ></b-form-input> </b-form-group></b-col></b-row
          ><b-row>
            <b-col>
              <b-form-group id="last-name-input-group">
                <b-form-input
                  class="form-control-auth"
                  v-bind:class="{
                    'form-control-auth-mid': client_name == 'MID',
                    'form-control-auth-doom-yoga': client_name == 'DY',
                  }"
                  id="last_name"
                  v-model="form.last_name"
                  type="text"
                  placeholder="Last name"
                  required
                ></b-form-input> </b-form-group></b-col
          ></b-row>

          <b-row>
            <b-col>
              <b-form-group id="mobile-number-input-group">
                <p
                  class=""
                  v-if="invalid_mobile_number"
                  v-bind:class="{
                    error_validation_message_p_mid: client_name == 'MID',
                    error_validation_message_p_dy: client_name == 'DY',
                  }"
                >
                  Please enter phone number
                </p>
                <vue-tel-input
                  v-if="client_name == 'DY'"
                  class="
                    form-control form-control-auth form-control-auth-doom-yoga
                  "
                  v-model="form.mobile_number"
                  required
                ></vue-tel-input>

                <vue-tel-input
                  v-else-if="client_name == 'MID'"
                  class="form-control form-control-auth form-control-auth-mid"
                  v-model="form.mobile_number"
                  required
                ></vue-tel-input> </b-form-group></b-col
          ></b-row>

          <!--<vue-tel-input
                        class="w-100"
                        v-bind:class="{
                          'form-control-doomyoga': client_name == 'DY',
                          'form-control-mid': client_name == 'MID',
                          'has-remove-action': phone_index != 0,
                        }"
                        :name="'phone' + index + '[]'"
                        :id="'phone' + index + '_' + phone_index"
                        v-model="phone.value"
                        required
                      ></vue-tel-input>-->
          <b-row>
            <b-col>
              <b-form-group id="email-input-group">
                <b-form-input
                  class="form-control-auth"
                  ref="emailinput"
                  v-bind:class="{
                    'form-control-auth-mid': client_name == 'MID',
                    'form-control-auth-doom-yoga': client_name == 'DY',
                  }"
                  id="email"
                  v-model="form.email"
                  type="email"
                  placeholder="Email"
                  required
                  @keydown.space.prevent
                ></b-form-input> </b-form-group></b-col
          ></b-row>
          <b-row v-if="is_guest != 'true'">
            <b-col>
              <b-form-group id="password-input-group">
                <b-form-input
                  class="form-control-auth"
                  v-bind:class="{
                    'form-control-auth-mid': client_name == 'MID',
                    'form-control-auth-doom-yoga': client_name == 'DY',
                  }"
                  id="password"
                  v-model="form.password"
                  type="password"
                  placeholder="Password"
                  required
                ></b-form-input> </b-form-group></b-col
          ></b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="level-input-group"
                :class="{
                  'form-group-auth-select-doomyoga': client_name == 'DY',
                  'form-group-auth-select-mid': client_name == 'MID',
                }"
              >
                <p
                  class=""
                  v-if="invalid_level"
                  v-bind:class="{
                    error_validation_message_p_mid: client_name == 'MID',
                    error_validation_message_p_dy: client_name == 'DY',
                  }"
                >
                  Please select level
                </p>
                <v-select
                  :options="levels"
                  name="level"
                  title="level"
                  v-model="form.level"
                  :reduce="(item) => item.code"
                  placeholder="Level"
                  required
                ></v-select>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row
            class="mt-2"
            v-bind:class="{
              checkboxInputContainerMID: client_name == 'MID',
              checkboxInputContainerDY: client_name == 'DY',
            }"
          >
            <b-col class="px-0">
              <b-form-group
                class="form-group-checkbox-group"
                :class="{
                  'form-group-check-doomyoga': client_name == 'DY',
                  'form-group-check-mid': client_name == 'MID',
                }"
                label="Prefered contact"
                label-class="mb-2"
                v-slot="{ ariaDescribedby }"
              >
                <p
                  class="error_validation_message_p"
                  v-if="invalid_contact_through"
                >
                  Please select prefered contact
                </p>
                <b-form-radio-group
                  id="occursOnCheckboxGroup"
                  v-model="form.contact_through"
                  name="contact_through"
                  required
                  :options="prefered_contact_options"
                  :aria-describedby="ariaDescribedby"
                ></b-form-radio-group> </b-form-group
            ></b-col>
          </b-row>

          <b-row
            class="mt-2"
            v-bind:class="{
              checkboxInputContainerMID: client_name == 'MID',
              checkboxInputContainerDY: client_name == 'DY',
            }"
          >
            <b-col class="px-0">
              <b-form-group
                class="form-group-checkbox-group"
                :class="{
                  'form-group-check-doomyoga': client_name == 'DY',
                  'form-group-check-mid': client_name == 'MID',
                }"
              >
                <b-form-checkbox
                  id="checkbox-get-updates"
                  v-model="form.get_updates"
                  name="get_updates"
                  value="1"
                  unchecked-value="0"
                >
                  I want to get updates about upcoming event and classes
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row
            class=""
            v-bind:class="{
              checkboxInputContainerMID: client_name == 'MID',
              checkboxInputContainerDY: client_name == 'DY',
            }"
          >
            <b-col class="px-0">
              <b-form-group
                class="form-group-checkbox-group"
                :class="{
                  'form-group-check-doomyoga': client_name == 'DY',
                  'form-group-check-mid': client_name == 'MID',
                }"
              >
                <b-form-checkbox
                  id="checkbox-agree-terms"
                  v-model="form.agree_terms"
                  name="agree_terms"
                  value="1"
                  unchecked-value="0"
                >
                  By signing up I agree to the
                  <a
                    class=""
                    href=""
                    :class="{
                      'checkbox-link-doomyoga': client_name == 'DY',
                      'checkbox-link-mid': client_name == 'MID',
                    }"
                  >
                    Terms & Conditions
                  </a>
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>

          <input type="hidden" name="client_name" v-model="client_name" />
          <div class="d-flex justify-content-center align-content-center">
            <button
              v-if="is_guest != 'true' && !is_loading"
              class="btn"
              v-bind:class="{
                'btn-login-mid': client_name === 'MID',
                'btn-login-dy': client_name === 'DY',
              }"
              type="submit"
              :disabled="form.agree_terms == 0"
            >
              Sign up
            </button>
            <b-button
              type="button"
              disabled
              variant="btn"
              v-bind:class="{
                'btn-login-mid': client_name === 'MID',
                'btn-login-dy': client_name === 'DY',
              }"
              v-if="is_guest != 'true' && is_loading"
            >
              <b-spinner
                small
                label="Small Spinner"
                variant="dark"
              ></b-spinner>
              Loading</b-button
            >
            <button
              v-if="is_guest == 'true'"
              class="btn"
              v-bind:class="{
                'btn-login-mid': client_name === 'MID',
                'btn-login-dy': client_name === 'DY',
              }"
              type="button"
              @click="clickProceedCheckout"
            >
              Proceed to checkout
            </button>
          </div>
          <div v-if="is_guest != 'true'">
            <div
              class="d-flex justify-content-center align-content-center mt-4"
              v-if="client_name == 'DY'"
            >
              <p
                class="mb-0"
                v-bind:class="{
                  rememberPasswordMIDP: client_name == 'MID',
                  rememberPasswordDYP: client_name == 'DY',
                }"
              >
                Already have an account?
                <router-link :to="'/' + clientLink + '/login'"
                  >Log in
                </router-link>
              </p>
            </div>
            <div
              class="d-flex justify-content-center align-content-center mt-1"
              v-if="client_name == 'DY'"
            >
              <p
                class="mb-0"
                v-bind:class="{
                  rememberPasswordMIDP: client_name == 'MID',
                  rememberPasswordDYP: client_name == 'DY',
                }"
              >
                OR
              </p>
            </div>
            <div
              class="d-flex justify-content-center align-content-center mt-1"
              v-if="client_name == 'DY'"
            >
              <p
                class="mb-0"
                v-bind:class="{
                  rememberPasswordMIDP: client_name == 'MID',
                  rememberPasswordDYP: client_name == 'DY',
                }"
              >
                <router-link to="/doom_yoga/home"
                  >Continue as a guest
                </router-link>
              </p>
            </div>
          </div>
        </b-form>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);

import axios from "axios";
import $ from "jquery";
export default {
  name: "Login",
  props: [
    "titleH2",
    "logoSrc",
    "client_name",
    "welcomeHeader",
    "welcomeSubheader",
    "clientLink",
    "is_guest",
  ],
  data() {
    return {
      form: {
        first_name: "",
        last_name: "",
        mobile_number: "",
        email: "",
        password: "",
        level: null,
        client_name: this.client_name,
        contact_through: null,
        get_updates: 0,
        agree_terms: 0,
      },
      user_id: null,
      showRegisterErrorMessage: false,
      registerErrorMessage: "",
      levels: [
        { label: "Beginner", code: "Beginner" },
        { label: "Intermediate", code: "Intermediate" },
        { label: "Advanced", code: "Advanced" },
      ],
      invalid_level: null,
      prefered_contact_options: [
        { text: "SMS", value: "sms" },
        { text: "Email", value: "email" },
      ],
      invalid_contact_through: false,
      invalid_mobile_number: false,
      is_loading: false,
    };
  },
  mounted() {
    // console.log(window.localStorage.getItem("user"));
    this.$emit("input", this.$refs.emailinput.value);
  },
  methods: {
    getImgUrl(imgname) {
      // var images = require.context("@/assets/images/", false, /\.png$/);
      // return images("./" + imgname );

      return require("@/assets/images/" + imgname);
    },
    onSubmit() {
      console.log("submit register ", this.is_guest);
      if (this.is_guest == "true") {
        this.clickProceedCheckout();
      } else {
        console.log("submit register customer");
        console.log(this.form);

        if (this.form.level == "" || this.form.level == null) {
          this.invalid_level = true;
        } else {
          this.invalid_level = false;
        }
        if (this.form.mobile_number == "" || this.form.mobile_number == null) {
          this.invalid_mobile_number = true;
        } else {
          this.invalid_mobile_number = false;
        }

        if (!this.invalid_level && !this.invalid_mobile_number) {
          console.log("validated from");
          this.sendRegisterRequest();
        }
      }
      // console.log(window.localStorage);
      // console.log("login submit");
      // console.log(this.$parent.$parent.isLogin);

      // if (this.form.client_name === "MID") {
      //   axios
      //     .post("admin/login", {
      //       email: this.form.email,
      //       password: this.form.password,
      //       client: this.form.client_name,
      //     })
      //     .then((response) => {
      //       console.log(response);
      //       console.log(response.data);
      //       this.loginErrorMessage = "";
      //       this.showLoginErrorMessage = false;
      //       window.localStorage.setItem("user", JSON.stringify(response.data));
      //       // // this.$parent.$parent.isLogin = true;
      //       // if (this.form.client_name === "MID") {
      //       this.$router.go({ name: "MIDDashboard" });
      //       // } else {
      //       //   this.$router.go({ name: "DoOmYogaDashboard" });
      //       // }
      //     })
      //     .catch((error) => {
      //       console.log(error.response.data.error);
      //       console.log(error.request);
      //       console.log(error.message);
      //       this.loginErrorMessage = error.response.data.error;
      //       this.showLoginErrorMessage = true;
      //     });
      // } else {
      //   axios
      //     .post("user/login", {
      //       email: this.form.email,
      //       password: this.form.password,
      //       client: this.form.client_name,
      //     })
      //     .then((response) => {
      //       console.log(response);
      //       console.log(response.data);
      //       window.localStorage.setItem("user", JSON.stringify(response.data));
      //       // // this.$parent.$parent.isLogin = true;
      //       if (this.form.client_name === "MID") {
      //         this.$router.go({ name: "MIDDashboard" });
      //       } else {
      //         this.$router.go({ name: "DoOmYogaDashboard" });
      //       }
      //     });
      // }
    },
    sendRegisterRequest() {
      console.log("in send register request");
      this.is_loading = true;
      let formData = new FormData();
      formData.append("client", this.client_name);
      formData.append("first_name", this.form.first_name);
      formData.append("second_name", this.form.last_name);
      formData.append("phone", this.form.mobile_number);
      formData.append("email", this.form.email);
      formData.append("password", this.form.password);

      axios
        .post("user/register", formData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
        .then((response) => {
          console.log(response);
          this.user_id = response.data.id;
          this.sendCustomerDataRequest();
          // this.$fire({
          //   // title: "Title",
          //   text: "Class is created successfully",
          //   type: "success",
          //   timer: 3000,
          // }).then((r) => {
          //   // console.log(r.value);
          // });
          // this.is_loading = false;
          // this.$router.go();
        })
        .catch((error) => {
          console.log(error.response);
          this.is_loading = false;
          this.$fire({
            // title: "Title",
            text: error.response.data.error,
            type: "error",
            customClass: {
              container: "swal-alert-doomyoga",
              confirmButton:
                "btn btn-bumblebee btn-doomyoga btn-doomyoga-primary btn-doom-yoga-submit",
              cancelButton:
                "btn btn-bumblebee btn-doomyoga btn-doomyoga-danger-outline btn-doom-yoga-submit",
            },
            // timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
        });
    },
    sendCustomerDataRequest() {
      console.log("in send dy customer data request");

      let formData = new FormData();
      formData.append("client", this.client_name);
      formData.append("user_id", this.user_id);
      formData.append("level", this.form.level);
      formData.append("notify_new_events", this.form.get_updates);
      formData.append("contact_through", this.form.contact_through);

      axios
        .post("user/create-profile", formData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
          },
        })
        .then((response) => {
          console.log(response);
          this.$fire({
            // title: "Title",
            text: response.data.success,
            type: "success",
            customClass: {
              container: "swal-alert-doomyoga",
              confirmButton:
                "btn btn-bumblebee btn-doomyoga btn-doomyoga-primary btn-doomyoga-submit",
              cancelButton:
                "btn btn-bumblebee btn-doomyoga btn-doomyoga-danger-outline btn-doomyoga-submit",
            },
            timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
          this.is_loading = false;

          this.$router.push({ name: "DoOmYogaLogin" } );
        })
        .catch((error) => {
          console.log(error.response);
          this.is_loading = false;
          this.$fire({
            // title: "Title",
            text: error.response.data.error
              ? error.response.data.error
              : error.response.data.message,
            type: "error",
            customClass: {
              container: "swal-alert-doomyoga",
              confirmButton:
                "btn btn-bumblebee btn-doomyoga btn-doomyoga-primary btn-doomyoga-submit",
              cancelButton:
                "btn btn-bumblebee btn-doomyoga btn-doomyoga-danger-outline btn-doomyoga-submit",
            },
            // timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
        });
    },
    clickProceedCheckout() {
      console.log("click proceed checkout from guest data ", this.is_guest);
      console.log(this.form);
      console.log(window.sessionStorage);

      let formdata = this.form;
      if (
        formdata.first_name == "" ||
        formdata.last_name == "" ||
        formdata.mobile_number == "" ||
        formdata.email == "" ||
        formdata.level == null ||
        formdata.contact_through == null ||
        formdata.contact_through == "" ||
        formdata.get_updates == false ||
        formdata.agree_terms == false
      ) {
        this.registerErrorMessage = "Please fill the fields";
        this.showRegisterErrorMessage = true;
      } else {
        this.registerErrorMessage = "";
        this.showRegisterErrorMessage = false;
        window.sessionStorage.setItem("first_name", this.form.first_name);
        window.sessionStorage.setItem("last_name", this.form.last_name);
        window.sessionStorage.setItem("mobile_number", this.form.mobile_number);
        window.sessionStorage.setItem("email", this.form.email);
        window.sessionStorage.setItem("level", this.form.level);
        window.sessionStorage.setItem(
          "contact_through",
          this.form.contact_through
        );
        window.sessionStorage.setItem("get_updates", this.form.get_updates);
        window.sessionStorage.setItem("agree_terms", this.form.agree_terms);
      }

      console.log(window.sessionStorage);
      this.$router.push({ name: "DoOmYogaCustomerEventsBookPayment" });
    },
  },
};
</script>
<style scoped>
body {
  min-height: 100vh !important;
}
</style>


// WEBPACK FOOTER //
// src/components/auth/Register.vue